import React from "react"
import moment from "moment"
import styled from "styled-components"
import { styleTheme } from "../../../../style/theme";
import { getPrimaryColor } from "../../../../style/utils";

import {
  SchedulableTime as SchedulableTimeModel,
} from "./types"

type Props = {
  schedulableTime: SchedulableTimeModel
  onChange: () => void
  facilityId: string
  meetingType: string
  chooseSchedule: (chosenSchedule: SchedulableTimeModel) => void
  primaryColor: string
  onClick:() => void
}

export const SchedulableTime: React.FC<Props> = (props) => {

  return (
    <StyledPage
      {...props}
    />
  )
}

type PageProps = Props & {
  className?: string
}
const Page: React.FC<PageProps> = (props) => {
  const { schedulableTime } = props

  const setState = (schedule: SchedulableTimeModel) => {
    props.chooseSchedule(schedule)
  }

  const toggleModal = () => {
    props.onClick()
  }

  const renderTitle = () => {
    const startTime = moment(schedulableTime.startAt).format("HH:mm");
    return (
      <button onClick={() => {setState(schedulableTime); toggleModal()}} disabled={!schedulableTime.isSchedulable}>
        {startTime}
      </button>
    )
  }

  return (
    <li className={props.className}>
      {renderTitle()}
    </li>
  )
}

const StyledPage = styled(Page)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;

  > button {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: ${getPrimaryColor};
    border: 1px solid ${getPrimaryColor};
    border-radius: 0.25rem;
    width: 100%;
    height: 58px;
    cursor: pointer;
    transition: 0.3s;
    background-color: ${styleTheme.colors.white};

    &:hover {
      background-color: ${getPrimaryColor};
      color: ${styleTheme.colors.white};
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
      color: ${getPrimaryColor};
      background-color: ${styleTheme.colors.gray.light};
    }
  }
`